import src from "IMAGE";
export default { src, width: 357, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFIaMmcVDyNJBAsdPAUNI0UFDCBBBQ4kRgUNIkMFDiNDABIQJkcIDiE9AwcSIQMGEBwCBg4YBQsbKwYOIzkFDB4wCkgHH48bq+cAAAAASUVORK5CYII="};
